import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-light-svg-icons';
import theme from './Tooltip.module.scss';

interface TooltipLoadingProps {}

const TooltipLoading: React.FC<TooltipLoadingProps> = (props) => {
    return (
        <div className={theme.loading}>
            <FontAwesomeIcon icon={faSpinnerThird} size="2x" spin />
        </div>
    );
};

export default TooltipLoading;
